import { IDropdownOption } from '@fluentui/react';
import { DropDown, DropDownPair } from 'src/Common/Models/UATConstants';

export interface IFiltersViewProps {}

export enum FieldType {
  CustomDropdown = 'CustomDropdown',
  PickerComponent = 'PickerComponent',
  Dropdown = 'Dropdown',
  DatePicker = 'DatePicker',
  TextField = 'TextField',
  SampleEditor = 'SampleEditor',
  Unknown = 'Unknown',
  PeoplePicker = 'PeoplePicker',
  Custom = 'Custom',
}
export interface IfieldList {
  fieldId: string;
  fieldName: string;
  fieldType: FieldType;
}
export interface IAreaField {
  selectedAreas: string[];
}
export interface IEOUField {
  selectedEOUs: string[];
}
export interface IAssignedTeam {
  selectedAssignedTeamList: string[];
}
export interface IActionOwner {
  selectedActionOwnerList: IDropdownOption[];
}
export interface IRequestorOwner {
  selectedRequestorOwnerList: IDropdownOption[];
}
export interface ISelectedStatusItem {
  selectedStatusItems: String[];
}
export interface IDropDownItems {
  selectedItems?: any;
  dropdownOptions?: any;
  placeholder: string;
  label: string;
  title?: string;
  disabled?: boolean;
  value?: any;
  disableSort?: boolean;
}

export interface IFilterItems {
  [x: string]: number;
  type: any;
  value: any;
}

export interface IMictosoftOwner {
  microsoftowner?: DropDownPair[];
  microsoftcoowner?: DropDownPair[];
}

export interface IuserData {
  items: DropDown[];
}
